import { css } from '@emotion/core';

export const searchBoxMobileOverlayWidthCSS = css`
    width: 100%;
`;
export const searchBoxMobileSearchBarCSS = ({ colors }) => css`
    height: 3rem;
    width: 100%;
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 1rem;
    border-bottom: 1px solid ${colors.neutral70};
`;

export const searchBoxMobileSearchInputCSS = () => css`
    width: 75%;
`;
